export default "__VITE_ASSET__930ec17d__"